import { OptimizelyFeatureFlags } from '@tgg/common-types';

import { useFlagsContext, useTggTheme } from '../../contexts';
import { Palette } from '../../theme';
import { Icon } from '../Icon/Icon';

import {
    iconColorMapNew,
    iconColorMapOld,
    StyledButton,
} from './IconButton.styled';
import { IconButtonProperties } from './IconButton.types';

export function IconButton({
    buttonStyle = 'primary',
    onClick,
    'aria-label': ariaLabel,
    type = 'button',
    disabled = false,
    icon,
    size = 'medium',
}: IconButtonProperties) {
    const { theme } = useTggTheme();
    const {
        flags: {
            [OptimizelyFeatureFlags.REBRANDING]: { enabled: isRebrand },
        },
    } = useFlagsContext();
    return (
        <StyledButton
            aria-label={ariaLabel}
            onClick={onClick}
            type={type}
            disabled={disabled}
            $style={buttonStyle}
            $size={size}
        >
            <Icon
                name={icon}
                color={
                    !isRebrand
                        ? (iconColorMapOld(theme)[buttonStyle] as Palette)
                        : (iconColorMapNew(theme, disabled)[
                              buttonStyle
                          ] as Palette)
                }
                size={isRebrand ? 22 : 20}
                {...(isRebrand && { viewBox: '0 0 24 24' })}
            />
        </StyledButton>
    );
}

export default IconButton;
